import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Icon, Segment } from 'semantic-ui-react';

import { isOrganizationSetupComplete } from '../../helpers/organizations';
import { useOrganization } from '../../hooks/useOrganizations';
import { useUser } from '../../hooks/useUser';
import OnboardingGoalButtonsContainer from './OnboardingGoalButtonsContainer';

// Define relative paths to SVG assets
import { ReactComponent as SunnyCloud } from './assets/SunnyCloud.svg';
import { ReactComponent as SunnyLeft } from './assets/SunnyLeft.svg';

type OnboardingBannerProps = {
  collapsed?: boolean;
  onClickUpDown?: (isCollapsed: boolean) => void;
};

const OnboardingBanner: React.FC<OnboardingBannerProps> = ({ collapsed = true, onClickUpDown }) => {
  const { t } = useTranslation();
  const { isDirector } = useUser();
  const organizationData = useOrganization();
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const extraClass = isCollapsed ? 'collapsed' : 'expanded';

  function OnboardingCollapsedBanner() {
    return (
      <div className="onboarding-banner-footer">
        <SunnyLeft className="size-20" />
        <div className="footer-text">{t('onboarding.collapsedMessage')}</div>
        <button
          type="button"
          className="toggle"
          aria-label={t('onboarding.collapsedMessage')}
          onClick={() => {
            setIsCollapsed(false);
            if (onClickUpDown) onClickUpDown(false);
          }}
        >
          <Icon name="chevron down" />
        </button>
      </div>
    );
  }

  function OnboardingExpandedBanner() {
    return (
      <>
        <div className="onboarding-wrapper">
          <div className="onboarding-banner-header">
            <div className="onboarding-inner-wrapper">
              <SunnyCloud className="h-44 w-full" />
            </div>
            <h1>{t('onboarding.welcome')}</h1>
            <p>{t('onboarding.iAmSunny')}</p>
          </div>
          <Segment className="buttons-section">
            <p className="mb-4">{t('onboarding.buttonsHeader')}</p>
            <OnboardingGoalButtonsContainer />
          </Segment>
        </div>
        <div className="onboarding-banner-footer">
          <SunnyLeft className="size-20 -scale-x-100" />
          <button
            type="button"
            className="footer-text"
            onClick={() => {
              setIsCollapsed(true);
              if (onClickUpDown) onClickUpDown(true);
            }}
          >
            {t('onboarding.exploreLink')}
          </button>
          <button
            type="button"
            className="toggle"
            aria-label={t('onboarding.exploreLink')}
            onClick={() => {
              setIsCollapsed(true);
              if (onClickUpDown) onClickUpDown(true);
            }}
          >
            <Icon name="chevron up" />
          </button>
        </div>
      </>
    );
  }

  return (
    isDirector &&
    !isOrganizationSetupComplete(organizationData) && (
      <div className={`onboarding-banner ${extraClass}`}>
        {isCollapsed ? <OnboardingCollapsedBanner /> : <OnboardingExpandedBanner />}
      </div>
    )
  );
};

export default OnboardingBanner;
